/**
 * Retrieves height of dom element
 *
 * @param  {Element} element
 * @return {number}
 */
export function getElementHeight(element: Element | string): number | undefined {
    const el = typeof element === 'string' ? document.querySelector(element) : element;
    if (el) {
        const rect = el.getBoundingClientRect();
        return rect.height;
    }
    return undefined;
}
